import { defineStore } from "pinia";
import axios from "axios";

export const supplyRequestStore = defineStore("supplyRequestStore", {
    state: () => ({
        supplyLoading: false,
        supplyRequestsCount: 0,
    }),
    actions: {
        async getCount() {
            this.setLoading(true);
            try {
                const res = await axios.get(
                    route("legacy-api.supplyRequestCount")
                );
                this.supplyRequestsCount = res.data.count;
            } catch (err) {
                console.log(err);
            }
            this.setLoading(false);
        },
        setLoading(isLoading) {
            this.loading = isLoading;
        },
    },
});
